let getters = {
}

export default getters
